import React, { useEffect, useState } from 'react';
import useApp from 'hooks/useApp'
import { Button, LayerBottom } from 'components'
import nhSymbol from 'images/tmp_nh_symbol.png'
import wooriSymbol from 'images/tmp_woori_symbol.png'
import shSymbol from 'images/tmp_shinhan_symbol.png'
import styles from './index.module.css'

const DataServiceCheck = () => {

	const App = useApp()
	const [tabList, setTabList] = useState(0)
	const [showLayer, setShowLayer] = useState(true)

	const closeLayer = () => {
		setShowLayer(false)
	}

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" onClick={App.goBack} />,
			right: <i className="icon icon_search" />
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		// 기획서에 있는 best 50 페이지는 탭안에 메뉴로 넣어 페이지 따로 필요하지 않다고 함
		<div className="page">
			<div className={`${styles["count-group"]} padding`}>
				<p>연결할 기관 선택</p>
				<div><span>1</span>/3</div>
			</div>
			<ul className="tab-round no-wrap no-scroll">
				<li onClick={() => setTabList(0)} className={`${tabList === 0 ? "active" : ""} flex-align_center`}>BEST <i className="icon icon_tab_best ml_5" /></li>
				<li onClick={() => setTabList(1)} className={tabList === 1 ? "active" : ""}>은행</li>
				<li onClick={() => setTabList(2)} className={tabList === 2 ? "active" : ""}>카드</li>
				<li onClick={() => setTabList(3)} className={tabList === 3 ? "active" : ""}>증권</li>
				<li onClick={() => setTabList(4)} className={tabList === 4 ? "active" : ""}>보험</li>
				<li onClick={() => setTabList(5)} className={tabList === 5 ? "active" : ""}>전자금융</li>
				<li onClick={() => setTabList(6)} className={tabList === 6 ? "active" : ""}>통신</li>
				<li onClick={() => setTabList(7)} className={tabList === 7 ? "active" : ""}>할부금융</li>
				<li onClick={() => setTabList(8)} className={tabList === 8 ? "active" : ""}>보증보험</li>
				<li onClick={() => setTabList(9)} className={tabList === 9 ? "active" : ""}>인수채권/대부</li>
				<li onClick={() => setTabList(10)} className={tabList === 10 ? "active" : ""}>P2P</li>
			</ul>
			<div className="padding">
				<div className="flex-justify_end">
					<div className="chk">
						<input type="checkbox" id="checkAll" name="state" />
						<label htmlFor="checkAll">
							<span style={{ color: "#333" }}>전체선택</span>
						</label>
					</div>
				</div>
				<ul className="check-area mt_10">
					<li>
						<div className="check-title">은행 <span>6</span></div>
						<div className="check-list">
							<div>
								<div>
									<div className="img-box img-symbol">
										<img src={nhSymbol} alt="" />
									</div>
									<p className="ml_10 ellipsis" style={{ width: "17rem" }}>NH농협은행</p>
								</div>
								<div>
									<div className="chk">
										<input type="checkbox" id="check1" name="check" />
										<label htmlFor="check1">
											<span></span>
										</label>
									</div>
								</div>
							</div>
							<div>
								<div>
									<div className="img-box img-symbol">
										<img src={wooriSymbol} alt="" />
									</div>
									<p className="ml_10 ellipsis" style={{ width: "17rem" }}>우리은행</p>
								</div>
								<div>
									<span className="connect mr_10">연결됨</span>
									<div className="chk">
										<input type="checkbox" id="check2" name="check" />
										<label htmlFor="check2">
											<span></span>
										</label>
									</div>
								</div>
							</div>
							<div>
								<div>
									<div className="img-box img-symbol">
										<img src={shSymbol} alt="" />
									</div>
									<p className="ml_10 ellipsis" style={{ width: "17rem" }}>은행명이길어질경우14자로노출됩니다.</p>
								</div>
								<div>
								<span className="connect mr_10">연결됨</span>
									<div className="chk">
										<input type="checkbox" id="check3" name="check" />
										<label htmlFor="check3">
											<span></span>
										</label>
									</div>
								</div>
							</div>
							<div>
								<div>
									<div className="img-box img-symbol">
										<img src={nhSymbol} alt="" />
									</div>
									<p className="ml_10 ellipsis" style={{ width: "17rem" }}>NH농협은행</p>
								</div>
								<div>
									<div className="chk">
										<input type="checkbox" id="check4" name="check" />
										<label htmlFor="check4">
											<span></span>
										</label>
									</div>
								</div>
							</div>
							<div>
								<div>
									<div className="img-box img-symbol">
										<img src={wooriSymbol} alt="" />
									</div>
									<p className="ml_10 ellipsis" style={{ width: "17rem" }}>우리은행</p>
								</div>
								<div>
								<span className="connect mr_10">연결됨</span>
									<div className="chk">
										<input type="checkbox" id="check5" name="check" />
										<label htmlFor="check5">
											<span></span>
										</label>
									</div>
								</div>
							</div>
							<div>
								<div>
									<div className="img-box img-symbol">
										<img src={shSymbol} alt="" />
									</div>
									<p className="ml_10 ellipsis" style={{ width: "17rem" }}>신한은행</p>
								</div>
								<div>
								<span className="connect mr_10">연결됨</span>
									<div className="chk">
										<input type="checkbox" id="check6" name="check" />
										<label htmlFor="check6">
											<span></span>
										</label>
									</div>
								</div>
							</div>
						</div>
					</li>
					<li>
						<div className="check-title">카드 <span>3</span></div>
						<div className="check-list">
							<div>
								<div>
									<div className="img-box img-symbol">
										<img src={nhSymbol} alt="" />
									</div>
									<p className="ml_10 ellipsis" style={{ width: "17rem" }}>NH농협은행</p>
								</div>
								<div>
									<div className="chk">
										<input type="checkbox" id="check7" name="check" />
										<label htmlFor="check7">
											<span></span>
										</label>
									</div>
								</div>
							</div>
							<div>
								<div>
									<div className="img-box img-symbol">
										<img src={wooriSymbol} alt="" />
									</div>
									<p className="ml_10 ellipsis" style={{ width: "17rem" }}>우리은행</p>
								</div>
								<div>
									<div className="chk">
										<input type="checkbox" id="check8" name="check" />
										<label htmlFor="check8">
											<span></span>
										</label>
									</div>
								</div>
							</div>
							<div>
								<div>
									<div className="img-box img-symbol">
										<img src={shSymbol} alt="" />
									</div>
									<p className="ml_10 ellipsis" style={{ width: "17rem" }}>신한은행</p>
								</div>
								<div>
									<div className="chk">
										<input type="checkbox" id="check9" name="check" />
										<label htmlFor="check9">
											<span></span>
										</label>
									</div>
								</div>
							</div>
						</div>
					</li>
				</ul>
			</div>

			<ConfirmLayer show={showLayer} closeLayer={closeLayer} />
		</div>
	)
}

const ConfirmLayer = ({ show, closeLayer }) => {
	return (
		<LayerBottom show={show} closeButton={false} closeConfirm={closeLayer} outside={
			<Button className="btn btn--big btn-layer" onClick={() => closeLayer()}>확인</Button>
		}>
			<div>
				<div className="flex-justify_center">
					<i className="icon icon_error_tri" style={{ width: "9.6rem", height: "6.9rem" }} />
				</div>
				<div className="layer-text mt_20">
					<p>지금은 서비스 점검중이에요.</p>
					<span style={{ color: "#999" }}>점검(23:00 ~ 00:30)이 끝나면 다시 시도해주세요.</span>
				</div>
			</div>
		</LayerBottom>
	)
}

export default DataServiceCheck